import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NcdtermsheetService } from 'src/app/services/NCD/ncdtermsheet.service';
import { Enums } from 'src/app/helpers/enums';
import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'app-edit-termsheet',
  templateUrl: './edit-termsheet.component.html',
  styleUrls: ['./edit-termsheet.component.css']
})
export class EditTermsheetComponent implements OnInit {

  @Input('termSheetFieldToEdit') termSheetFieldToEdit: any
  @Input('issueIdToEdit') issueIdToEdit: any

  dropDownList: any;
  text: any;
  number: any;
  numberWithoutZero: any;

  addNewTermsheetFieldForm: FormGroup;
  newFieldArray: Array<any> = [];
  newFieldAttribute: any;
  originalTermsheetDataArray: any[];
  deleteTermsheetFieldId: any;
  listOfValuesArray: any[];
  termsheetIdToUpdate: any;
  firstGetCall: Boolean = false;
  PreviousIndex: any;
  termsheetFieldById: any;
  public newFieldNameSearchParm: any;
  defaultSelected: any;
  isDefaultChecked: boolean;
  isMoreOptionOpened: boolean = false;
  fieldUpdated: boolean = false;
  disabledOnClick: boolean = false;


  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  constructor( private alert: AlertComponent, public activeModal: NgbActiveModal, 
    private formBuilder: FormBuilder, private ncdTermsheetService: NcdtermsheetService) { }

  ngOnInit() {
    this.dropDownList = Enums.NCDFieldType.dropDown;
    this.text = Enums.NCDFieldType.text;
    this.number = Enums.NCDFieldType.number;
    this.numberWithoutZero = Enums.NCDFieldType.numberWithoutZero;
    //console.log("termSheetFieldToEdit =======", this.termSheetFieldToEdit)
    ////console.log("this.issueIdToEdit =======", this.issueIdToEdit)



    this.addNewTermsheetFieldForm = this.formBuilder.group({
      fieldValue: ['', [Validators.required]],
      newFieldValue: ['', [Validators.required]],
    });

    this.addNewTermsheetFieldForm.controls.fieldValue.setValue(this.termSheetFieldToEdit.DefaultValue);

    // get Library Data
    this.originalTermsheetDataArray = [];
    this.ncdTermsheetService.getTermsheetData({ isSearch: false }).subscribe((termsheetList:any) => {
      this.originalTermsheetDataArray = termsheetList.data;
      ////console.log("this.originalTermsheetDataArray", this.originalTermsheetDataArray);
    });
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  onlyNumberWithoutZero(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 48 && keyCode < 58) || (keyCode > 96 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  initialiseNewFieldArray(): FormGroup {
    const group = new FormGroup({
    })
    return group;
  }

  updateTermsheet() {
    this.termSheetFieldToEdit.DefaultValue = this.addNewTermsheetFieldForm.controls.fieldValue.value;
  }

  updateOnlyInTermsheet(buttonClicked) {
    this.disabledOnClick = true;
    var listOfValuesArray = [];
    listOfValuesArray = this.termSheetFieldToEdit.ListOfValues;
    let defaultValueSelectedBefore = this.termSheetFieldToEdit.DefaultValue;
    var listOfValuesArrayLength = listOfValuesArray.length
    var defaultValueToShow = this.addNewTermsheetFieldForm.controls.fieldValue.value
    for (var i = 0; i < listOfValuesArrayLength; i++) {
      listOfValuesArray[i]['defaultValue' + i] = false;
      if (listOfValuesArray[i]['newFieldValue' + i] === defaultValueSelectedBefore) {
        listOfValuesArray[i]['newFieldValue' + i] = this.addNewTermsheetFieldForm.controls.fieldValue.value;
        listOfValuesArray[i]['staticValue' + i] = this.addNewTermsheetFieldForm.controls.fieldValue.value;
        listOfValuesArray[i]['defaultValue' + i] = true;
      }
    }

    if (this.addNewTermsheetFieldForm.controls.newFieldValue.value != '') {
      let newField = 'newFieldValue' + listOfValuesArrayLength;
      let defaultValue = 'defaultValue' + listOfValuesArrayLength;
      let staticValue = 'staticValue' + listOfValuesArrayLength;
      defaultValueToShow = this.addNewTermsheetFieldForm.controls.newFieldValue.value
      var newObject = {
        [defaultValue]: true,
        [newField]: this.addNewTermsheetFieldForm.controls.newFieldValue.value,
        [staticValue]: this.addNewTermsheetFieldForm.controls.newFieldValue.value
      }
      listOfValuesArray.push(newObject);
    }

    var object = {
      fieldName: this.termSheetFieldToEdit.FieldName,
      defaultValue: defaultValueToShow,
      issueId: this.issueIdToEdit,
      idOfFieldObjectToUpdate: this.termSheetFieldToEdit._id,
      listOfValues: listOfValuesArray,
      libraryId: this.termSheetFieldToEdit.LibraryId
    }
    this.ncdTermsheetService.updateIssueSpecificTermsheet(object).subscribe((updatedFieldDate:any) => {
      //console.log("updatedFieldDate++++++++++++++",updatedFieldDate);
      this.disabledOnClick = false;
      if (updatedFieldDate.status == 0) {
        if (buttonClicked == 'TermsheetNLibrary') {
          this.updateInLibraryAndTermsheet()
        } else {
          this.activeModal.close();
          this.alert.successWithOk(updatedFieldDate.message, '/ncd-issue/edit/' + this.issueIdToEdit)
        }
      }
      else{
        this.activeModal.close();
        if(updatedFieldDate.errFields){
          this.alert.error( JSON.stringify(updatedFieldDate.errFields) + ' fields are required');
        } else if(updatedFieldDate.error){
          this.alert.error( JSON.stringify(updatedFieldDate.error) + ' fields are required');
        }else{
          this.alert.error(updatedFieldDate.message);
        }
      }
    })
  }

  updateInLibraryAndTermsheet() {
    this.disabledOnClick = true;
    for (let i = 0; i < this.originalTermsheetDataArray.length; i++) {
      if (this.originalTermsheetDataArray[i].FieldName == this.termSheetFieldToEdit.FieldName) {
        var listOfValuesArray = [];
        listOfValuesArray = this.originalTermsheetDataArray[i].ListOfValues;
        let defaultValueSelectedBefore = this.termSheetFieldToEdit.DefaultValue;
        var listOfValuesArrayLength = listOfValuesArray.length
        var defaultValueToShow = this.addNewTermsheetFieldForm.controls.fieldValue.value
        for (let j = 0; j < listOfValuesArrayLength; j++) {
          listOfValuesArray[j]['defaultValue' + j] = false;
          if (listOfValuesArray[j]['staticValue' + j] === defaultValueSelectedBefore) {
            this.fieldUpdated = true;
            listOfValuesArray[j]['newFieldValue' + j] = this.addNewTermsheetFieldForm.controls.fieldValue.value;
            listOfValuesArray[j]['staticValue' + j] = this.addNewTermsheetFieldForm.controls.fieldValue.value;
            listOfValuesArray[j]['defaultValue' + j] = true;
          }
        }
        if (this.fieldUpdated == false) {
          let newField = 'newFieldValue' + listOfValuesArrayLength;
          let defaultValue = 'defaultValue' + listOfValuesArrayLength;
          let staticValue = 'staticValue' + listOfValuesArrayLength;
          defaultValueToShow = this.addNewTermsheetFieldForm.controls.fieldValue.value
          var newObject = {
            [defaultValue]: true,
            [newField]: this.addNewTermsheetFieldForm.controls.fieldValue.value,
            [staticValue]: this.addNewTermsheetFieldForm.controls.fieldValue.value
          }
          listOfValuesArray.push(newObject);
        }
        break;
      }
    }

    var objectToUpdateInTermsheetAndLibrary = {
      fieldName: this.termSheetFieldToEdit.FieldName,
      defaultValue: defaultValueToShow,
      listOfValues: listOfValuesArray,
      libraryId: this.termSheetFieldToEdit.LibraryId,
      issueId: this.issueIdToEdit,
    }
    this.ncdTermsheetService.updateIssueSpecificTermsheetInLibrary(objectToUpdateInTermsheetAndLibrary).subscribe((updatedFieldDate:any) => {
      this.disabledOnClick = false;
      if (updatedFieldDate.status == 0) {
        //console.log("updatedFieldDate",updatedFieldDate);
        this.activeModal.close();
        this.alert.successWithOk(updatedFieldDate.message, '/ncd-issue/edit/' + this.issueIdToEdit)
      }
      else{
        this.activeModal.close();
        // this.alert.error(updatedFieldDate.message);
        if(updatedFieldDate.errFields){
          this.alert.error( JSON.stringify(updatedFieldDate.errFields) + ' fields are required');
        } else if(updatedFieldDate.error){
          this.alert.error( JSON.stringify(updatedFieldDate.error) + ' fields are required');
        }else{
          this.alert.error(updatedFieldDate.message);
        }
      }
    })
  }

  clickedMoreOption() {
    var moreOptionOpenedClass = $('.card-block').hasClass('show');
    if (moreOptionOpenedClass == false) {
      // elements with class "snake--mobile" exist
      this.isMoreOptionOpened = true;
    } else {
      this.isMoreOptionOpened = false;
      this.addNewTermsheetFieldForm.controls.newFieldValue.setValue('')
    }
  }


}
